import { Modal } from '../classen/Modals';

export function initModals() {
    window.Modals = [];
    document.querySelectorAll('[data-modal]').forEach((item) => {
        const modal = new Modal(item, {
            type: 'inline',
            touch: false
        });
        window.Modals.push(modal);
        modal.init();
    });
}
